import { render, staticRenderFns } from "./SendSampleDialog.vue?vue&type=template&id=58f23fbb&scoped=true"
import script from "./SendSampleDialog.vue?vue&type=script&lang=js"
export * from "./SendSampleDialog.vue?vue&type=script&lang=js"
import style0 from "./SendSampleDialog.vue?vue&type=style&index=0&id=58f23fbb&prod&scoped=true&lang=css"
import style1 from "./SendSampleDialog.vue?vue&type=style&index=1&id=58f23fbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f23fbb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDivider,VFadeTransition,VForm,VIcon,VProgressLinear,VSlideXTransition,VSpacer,VTextField})
